import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const h = a((e, r) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: r,
    ...e,
    image: (t) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3444",
              width: 16,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M14.8 2H.75C.34 2 0 2.34 0 2.75v2.29c0 .66.54 1.2 1.2 1.2h11.62c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H1.5V3.5h13v8.94h-13V7.79c0-.41-.34-.75-.75-.75S0 7.38 0 7.79v4.95c0 .66.54 1.2 1.2 1.2h13.6c.66 0 1.2-.54 1.2-1.2V3.2c0-.66-.54-1.2-1.2-1.2"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M6.65 10.52c.41 0 .75-.34.75-.75v-2c0-.41-.34-.75-.75-.75h-2.9c-.41 0-.75.34-.75.75v1.99c0 .41.34.75.75.75h2.9zm-2.15-2h1.4v.49H4.5z"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3444)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
h.displayName = "AgencyPaymentIcon";
export {
  h as AgencyPaymentIcon,
  h as default
};
//# sourceMappingURL=index.js.map
